/* import { Modal } from '@mui/material'; */
import clsx from 'clsx';
import ModalContainer from 'components/ModalContainer';
import { useState, useEffect } from 'react';
import { useSelectedContext } from 'context/contextSelector';
import { getBrowser } from 'utils/defineBrowser';
import useIsTouchDevice from 'utils/useIsTouchDevice';
import styles from './ErrorModal.module.scss';

const ErrorModal = ({
  isModelOpen,
  setIsOpen,
  handleClose,
  title,
  subTitle,
  isOrientationModal,
  isKeyboardOpen,
}) => {
  const [browser, setBrowser] = useState();
  const { setIsError } = useSelectedContext((context) => context.app);

  const isTouchDevice = useIsTouchDevice();

  useEffect(() => {
    setBrowser(getBrowser());
  }, []);

  return (
    // <Modal
    //   open={isModelOpen === undefined ? true : isModelOpen}
    //   aria-labelledby="modal-modal-title"
    //   aria-describedby="modal-modal-description"
    //   sx={{
    //     backgroundColor: 'white',
    //     display: 'none',
    //     '@media only screen and (max-width: 1024px) and (orientation:landscape)': {
    //       display: 'block',
    //     },
    //   }}
    //   BackdropProps={{ style: { backgroundColor: '#fff' } }}
    // >
    //   <ModalContainer
    //     background="no-repeat center/100% url(/images/error-bg.png)"
    //     // handleClose={() => {}}
    //     isErrorModal
    //   >
    //     {title && <div className={styles.title}>{title}</div>}
    //     {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
    //     {handleClose && (
    //       <button className={styles.btn} type="button" onClick={() => handleClose(setIsOpen)}>
    //         OK
    //       </button>
    //     )}
    //   </ModalContainer>
    // </Modal>
    <>
      {isModelOpen ? (
        <div
          className={clsx(
            styles.errorModalWrapper,
            isOrientationModal ? styles.orientationModalWrapper : '',
            isKeyboardOpen && !browser.isSafari ? styles.keyboardVisible : '',
            !isTouchDevice ? styles.desktop : ''
          )}
        >
          <ModalContainer
            background={
              isOrientationModal ? '#212121' : 'no-repeat center/100% url(/images/error-bg.png)'
            }
            handleClose={() => {
              handleClose(setIsOpen);
              if (!isOrientationModal) {
                setIsError(false);
              }
            }}
            isErrorModal
            isOrientationModal
          >
            {title && <div className={styles.title}>{title}</div>}
            {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
            {handleClose && (
              <button
                className={styles.btn}
                type="button"
                onClick={() => {
                  handleClose(setIsOpen);
                  if (!isOrientationModal) {
                    setIsError(false);
                  }
                }}
              >
                OK
              </button>
            )}
          </ModalContainer>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default ErrorModal;
